import * as types from '../../lib/actionTypes.es6';
import * as actions from './actions.es6';
import {
  makeLatestWatcher,
  makeLeadingWatcher
} from '../../components/CommissionsShared/makeWatcher.es6';
import {
  getCommissionSettings,
  updateCommissionSettings
} from '../../lib/requests.es6';

export var getCommissionSettingsRequestWatcher = makeLatestWatcher(
  types.GET_COMMISSION_SETTINGS_REQUEST,
  getCommissionSettings,
  actions.getCommissionSettingsSuccess,
  actions.getCommissionSettingsFailed,
  { args: function() { return []; } }
);

export var updateCommissionSettingsRequestWatcher = makeLeadingWatcher(
  types.UPDATE_COMMISSION_SETTINGS_REQUEST,
  updateCommissionSettings,
  actions.updateCommissionSettingsSuccess,
  actions.updateCommissionSettingsFailed
);
